import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, take, takeUntil } from 'rxjs';
import { BannerItem } from 'src/app/apollo/models/base-models';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { DesktopService } from 'src/app/services/desktop/desktop.service';
import SwiperCore, { Autoplay, Lazy, Pagination, SwiperOptions } from 'swiper';
import { PaginationOptions } from 'swiper/types';
import { isPlatformServer } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HidePromotionsService } from 'src/app/services/utils/hide-promotions.service';
import { LICENCE } from 'src/app/global.tokens';
import { filterBannerLicence } from 'src/app/utils/licence_filter';

SwiperCore.use([Lazy, Pagination, Autoplay]);

@Component({
  selector: 'app-desktop-banner',
  templateUrl: './desktop-banner.component.html',
  styleUrls: ['./desktop-banner.component.scss'],
  animations: [
    trigger('bannerAnimation', [
      state('visible', style({
        height: '*',
        opacity: 1
      })),
      state('hidden', style({
        height: '0',
        opacity: 0,
        overflow: 'hidden'
      })),
      transition('visible <=> hidden', [
        animate('0.5s ease-in-out')
      ])
    ])
  ]
})
export class DesktopBannerComponent extends BasePageComponent implements OnInit {

  config: SwiperOptions = {
    direction: 'horizontal',
    lazy: {
      loadPrevNext: true,
    },
    preloadImages: false,
    scrollbar: false,
    watchSlidesProgress: true,
    navigation: false,
    keyboard: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    centeredSlides: true,
    loop: true,
    roundLengths: true,
    spaceBetween: 0,
    pagination: {
      clickable: true,
    }
  };

  pagination: PaginationOptions = {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
    renderBullet: (index, className) => {
      return `<div class="${className}"></div>`;
    }
  };

  unfilteredItems: BannerItem[];
  topBanner: BannerItem[];
  isAuthenticated: boolean;
  isServer: boolean;

  bannerState: 'visible' | 'hidden' = 'visible';

  constructor(
    private desktopService: DesktopService,
    private loginStatusService: LoginStatusService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId,
    @Inject(LICENCE) private licence,
    private route: ActivatedRoute,
    private hidePromotionsService: HidePromotionsService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.isServer = isPlatformServer(this.platformId);

    this.hidePromotionsService.setBannerExist(true);

    this.hidePromotionsService.isShowBanner().pipe(takeUntil(this.unsubscribe)).subscribe(showBanner => {
      this.bannerState = showBanner ? 'visible' : 'hidden';
    });

    this.hidePromotionsService.setBannerExist(true);

    this.getBannerData();
  }

  getBannerData() {
    this.desktopService.bannerData().valueChanges.pipe(take(1)).subscribe(res => {
      this.unfilteredItems = filterBannerLicence(res.data.banners, this.licence).bannerItems;
      this.isAuth();
    });
  }

  isAuth() {
    this.loginStatusService.getLoginStatus().pipe(takeUntil(this.unsubscribe),
      filter(resp => resp.isLogged !== LoggedStatus.voidState)
    ).subscribe(resp => {
      this.isAuthenticated = resp.isLogged === LoggedStatus.logged;
      this.filterAndSetBannerItems(this.isAuthenticated);
    });
  }

  openLink(item: BannerItem) {
    this.router.navigate((this.isAuthenticated ? item.loggedButtonLink : item.buttonLink).split('/'), {relativeTo: this.route});
  }

  trackByBannerItems(index: number, item: BannerItem): string {
    return item.name;
  }

  private filterAndSetBannerItems(isAuthenticated: boolean) {
    if (isAuthenticated) {
      this.topBanner = this.unfilteredItems?.filter(item => !item.hideForLogged);
    } else {
      this.topBanner = this.unfilteredItems?.filter(item => !item.hideForNotLogged);
    }
  }

  ngOnDestroy(): void {
    this.hidePromotionsService.setBannerExist(false);
    this.hidePromotionsService.resetShowBanner();
  }
}
